module.exports = __webpack_public_path__ + "static/media/homepageBg5.7e047f22.png";